import React, { useState } from "react";
import { Card, List, Tooltip, Tag, Badge, Tabs } from "antd";
import {
  CarOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
  UserOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import InfractionStatus from "./InfractionStatus";
import WarningStatus from "./WarningStatus";
import { formatDateTime } from "../utils/constants";

const RecentItems = ({ infractions = [], warnings = [] }) => {
  const [activeTab, setActiveTab] = useState("infractions");

  const getTimeDifference = (datetime) => {
    const now = new Date();
    const itemTime = new Date(datetime);
    const diffInMinutes = Math.floor((now - itemTime) / (1000 * 60));

    if (diffInMinutes < 60) return `${diffInMinutes} min`;
    if (diffInMinutes < 1440)
      return `${Math.floor(diffInMinutes / 60)}h ${diffInMinutes % 60}min`;
    return `${Math.floor(diffInMinutes / 1440)}j`;
  };

  const renderList = (items, type) => (
    <List
      dataSource={items}
      renderItem={(item) => (
        <List.Item
          actions={[
            type === "infractions" ? (
              <InfractionStatus status={item?.status || "pending"} />
            ) : (
              <WarningStatus status={item?.status || "pending"} />
            ),
            <Tooltip title="Voir les détails">
              <a
                href={`/${type === "infractions" ? "infraction" : "warning"}/${
                  item?.id
                }`}
                className="text-blue-600"
                target="_blank"
              >
                Détails
              </a>
            </Tooltip>,
          ]}
        >
          <List.Item.Meta
            avatar={
              type === "infractions" ? <CarOutlined /> : <WarningOutlined />
            }
            title={
              <div className="flex items-center gap-2">
                <span>
                  {item?.type_infraction?.name || item?.type_warning?.name}
                </span>
                <Tooltip
                  title={formatDateTime(
                    item?.[`datetime_${type.slice(0, -1)}`]
                  )}
                >
                  <Tag icon={<ClockCircleOutlined />}>
                    {getTimeDifference(item?.[`datetime_${type.slice(0, -1)}`])}
                  </Tag>
                </Tooltip>
              </div>
            }
            description={
              <div>
                {item.location && (
                  <div>
                    <EnvironmentOutlined /> {item.location}
                  </div>
                )}
                {item.user.full_name && (
                  <div>
                    <UserOutlined /> Constateur: {item.user.full_name}
                  </div>
                )}
              </div>
            }
          />
        </List.Item>
      )}
      locale={{
        emptyText:
          type === "infractions" ? "Aucune infraction" : "Aucun avertissement",
      }}
    />
  );

  const items = [
    {
      key: "infractions",
      label: (
        <span>
          Infractions
          <Tag color="blue" className="ml-2">
            5 dernières
          </Tag>
        </span>
      ),
      children: renderList(infractions, "infractions"),
    },
    {
      key: "warnings",
      label: (
        <span>
          Avertissements
          <Tag color="orange" className="ml-2">
            5 derniers
          </Tag>
        </span>
      ),
      children: renderList(warnings, "warnings"),
    },
  ];

  return (
    <Card
      title={
        <div className="flex items-center justify-between">
          <span className="text-lg font-semibold">
            5 Dernières Notifications
          </span>
          <Tooltip title="Actualisé en temps réel">
            <Badge status="processing" text="Live" />
          </Tooltip>
        </div>
      }
      className="hover:shadow-lg transition-shadow h-full"
    >
      <Tabs
        activeKey={activeTab}
        items={items}
        onChange={setActiveTab}
        className="w-full"
      />
    </Card>
  );
};

export default RecentItems;
